// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";

const useRedirectToSignInWithReturnAddress = () => {
    const signInUrl = useAppSelector(state => getPageLinkByPageType(state, "SignInPage")?.url) || "SignIn";
    const currentLocation = useAppSelector(state => getLocation(state));
    const history = useHistory();
    return () =>
        history.push(`${signInUrl}?returnUrl=${currentLocation.pathname + currentLocation.search}&clientRedirect=true`);
};

export default useRedirectToSignInWithReturnAddress;
